import { useState } from 'react';
import { useAuth } from '@/features/auth';
import { useImpersonation } from '@/features/auth/hooks/useImpersonation';
import type { NavItem } from '../navigation';
import { getNavItems } from '../navigation';
import { getSidebarClassNames, type SidebarClassNames } from './sidebarClassNames';

interface SidebarState extends SidebarClassNames {
  isMobileOpen: boolean;
  isCollapsed: boolean;
  navItems: NavItem[];
  displayRoles: string[];
  userName: string | undefined;
  toggleMobile: () => void;
  closeMobile: () => void;
  toggleCollapse: () => void;
}

export function useSidebarState(): SidebarState {
  const { user, activeRole } = useAuth();
  const { isImpersonating, effectiveCompanyId, effectiveRoles } = useImpersonation();
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const userRoles = user?.roles ?? [];
  const navItems = getNavItems(isImpersonating, effectiveCompanyId, activeRole);
  const displayRoles = isImpersonating ? (effectiveRoles as string[]) : userRoles;

  return {
    isMobileOpen,
    isCollapsed,
    navItems,
    displayRoles,
    userName: user?.profile.fullName,
    toggleMobile: () => setIsMobileOpen((prev) => !prev),
    closeMobile: () => setIsMobileOpen(false),
    toggleCollapse: () => setIsCollapsed((prev) => !prev),
    ...getSidebarClassNames(isCollapsed, isMobileOpen),
  };
}
